import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { BlogService } from 'src/app/services/blog.service';

@Component({
  selector: 'app-column-left-sidebar',
  templateUrl: './column-left-sidebar.component.html',
  styleUrls: ['./column-left-sidebar.component.scss']
})
export class ColumnLeftSidebarComponent implements OnInit {
  category
  defaultImage = `https://dummyimage.com/835x430/9e9e9e.jpg&text=+`

  constructor(
    private apiService: ApiService,
    private router: Router,
    public blogService: BlogService,
  ) {  }

  ngOnInit() {
    const { category } = window.history.state
    if(category) {
      this.category = category
    }
  }
  
  filterByCategory = (category) => {
    this.category = category
  }

}
